import type SkypeTeamsPropertiesData from 'owa-calendar-types/lib/types/SkypeTeamsPropertiesData';
import { ClientFolderId, MailboxInfo, getUserMailboxInfo } from 'owa-client-ids';
import { orchestrator } from 'satcheljs';
import {
    onChannelChanged,
    onParentFolderIdChanged,
    onSkypeTeamsPropertiesChanged,
    onIsOnlineMeetingChanged,
} from 'owa-calendar-compose-form-actions';
import { getFolderIdByCalendarID } from 'owa-calendar-cache';
import {
    setTeamsChannelCalendarColorScheme,
    extractHostFromChannelId,
} from 'owa-calendar-teams-utils';

// Work Item 58585: Clean code once the teams/channels are added to the cache

export default orchestrator(onChannelChanged, actionMessage => {
    const { channelOption } = actionMessage;
    const teamSmtpAddress = channelOption.parentTeamSmtpAddress;
    const mailboxInfo: MailboxInfo = {
        userIdentity: getUserMailboxInfo().userIdentity,
        mailboxSmtpAddress: teamSmtpAddress,
        type: 'TeamsMailbox',
    };

    let folderId: ClientFolderId;

    const trimmedChannelId = extractHostFromChannelId(channelOption.id);
    const cachedFolderId = getFolderIdByCalendarID(trimmedChannelId);

    if (cachedFolderId) {
        folderId = {
            Id: cachedFolderId,
            mailboxInfo: mailboxInfo,
        };
    } else {
        folderId = {
            Id: trimmedChannelId,
            mailboxInfo: mailboxInfo,
        };

        setTeamsChannelCalendarColorScheme(folderId.Id);
    }

    onParentFolderIdChanged(folderId);

    const skypeTeamsProperties: SkypeTeamsPropertiesData = {
        cid: channelOption.id,
        rid: channelOption.rid,
        mid: channelOption.mid,
        uid: channelOption.uid,
        private: channelOption.private,
        type: channelOption.channelType,
    };
    onSkypeTeamsPropertiesChanged(skypeTeamsProperties);

    // Set isOnlineMeeting when we have a channel meeting
    onIsOnlineMeetingChanged(
        true,
        'TeamsForBusiness',
        false /* isOnlineMeetingExplicitlySet */,
        false /* wasOnlineMeetingEverAutoSet */
    );
});
